import { Box, CardMedia, Icon, Typography } from '@mui/material'
// import StarsIcon from '@mui/icons-material/Stars'
import Tags from './Tags'
import { StarRateRounded } from '@mui/icons-material'

export const AppliedAndMatchedColumn = [
  {
    Header: 'Name',
    accessor: 'relations.candidateable.name',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      const date = new Date(props?.row?.original?.created_at)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })

      const profile_type = props?.row?.original?.relations?.candidateable?.profile_type
      const application_type = props?.row?.original?.relations?.application_type

      const getProfileMessage = (profileType, date) => {
        if (
          application_type === 'self apply' ||
          application_type === 'self apply through job recommender' ||
          application_type === 'self apply & matched' ||
          application_type === 'self apply through job recommender & matched'
        ) {
          switch (profileType) {
            case 'jobseeker':
              return `Applied via adnexio on ${date}`
            case 'job_board':
              return `Applied via Job board on ${date}`
            default:
              return `Applied via External on ${date}`
          }
        } else {
          switch (profileType) {
            case 'jobseeker':
              return `Matched via adnexio`
            case 'job_board':
              return `Matched via Job board`
            default:
              return `Matched via External`
          }
        }
      }
      const message = getProfileMessage(profile_type, formattedDate)

      return (
        <Box display="flex" alignItems="center">
          {props?.row?.original?.relations?.candidateable?.pricing?.is_unlocked ? (
            <Box>
              {props?.row?.original?.relations?.candidateable?.profile_image_url !== null ? (
                <CardMedia
                  component="img"
                  sx={{
                    marginRight: 2,
                    height: 45,
                    width: 45,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                  src={props?.row?.original?.relations?.candidateable?.profile_image_url}
                />
              ) : props?.row?.original?.relations?.application_type ===
                'matched by candidate recommender' ? (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="gray-background.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon
                    sx={{
                      color: 'light-gray-text.main',
                    }}
                  >
                    person_outline_outlined
                  </Icon>
                </Box>
              ) : (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="alternate.main"
                  color="white.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    textTransform: 'capitalize',
                  }}
                >
                  {value?.charAt(0) || '?'}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="gray-background.main"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'light-gray-text.main',
                }}
              >
                locked
              </Icon>
            </Box>
          )}

          <Box display="flex" flexDirection="column" columnGap={2}>
            <Typography sx={{ textTransform: 'capitalize', wordWrap: 'break-word', maxWidth: 500 }}>
              {value || props?.row?.original?.id}
            </Typography>
            <Box display="flex" alignItems="center" columnGap={1}>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor:
                    profile_type === 'jobseeker'
                      ? 'alternate.main'
                      : profile_type === 'job_board'
                      ? 'information.main'
                      : 'yellow-01.main',
                }}
              ></Box>
              <Typography variant="body2" color="light-gray-text.main">
                {message}
              </Typography>
            </Box>
          </Box>
        </Box>
      )
    },
  },

  // {
  //   Header: 'Profile score',
  //   accessor: 'relations.candidateable.profile_scores.total_score',
  //   Cell: (props) => {
  //     const { value } = props
  //     return (
  //       <Box display="flex" alignItems="center" justifyContent="start" columnGap={1}>
  //         {value ? (
  //           <>
  //             <StarsIcon color="yellow-01" />
  //             <Typography>{value ? value : '9.9'}</Typography>
  //           </>
  //         ) : (
  //           <Typography>Not available</Typography>
  //         )}
  //       </Box>
  //     )
  //   },
  // },

  {
    Header: 'Job fit',
    accessor: 'average_job_fit_score',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      const job_fit = String(props?.row?.original?.average_job_fit_score)

      const getJobFit = (jobFit) => {
        switch (jobFit) {
          case '5':
            return (
              <Box display="flex" flexDirection="column">
                <Box display="flex" flexDirection="row" marginBottom={0.5}>
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                </Box>
                <Typography>Strongly fit</Typography>
              </Box>
            )
          case '4':
            return (
              <Box display="flex" flexDirection="column">
                <Box display="flex" flexDirection="row" marginBottom={0.5}>
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="gray-line" />
                </Box>
                <Typography>Well fit</Typography>
              </Box>
            )
          case '3':
            return (
              <Box display="flex" flexDirection="column">
                <Box display="flex" flexDirection="row" marginBottom={0.5}>
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="gray-line" />
                  <StarRateRounded color="gray-line" />
                </Box>
                <Typography>Averagely fit</Typography>
              </Box>
            )
          case '2':
            return (
              <Box display="flex" flexDirection="column">
                <Box display="flex" flexDirection="row" marginBottom={0.5}>
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="gray-line" />
                  <StarRateRounded color="gray-line" />
                  <StarRateRounded color="gray-line" />
                </Box>
                <Typography>Partially fit</Typography>
              </Box>
            )
          default:
            return (
              <Box display="flex" flexDirection="column">
                <Box display="flex" flexDirection="row" marginBottom={0.5}>
                  <StarRateRounded color="yellow-01" />
                  <StarRateRounded color="gray-line" />
                  <StarRateRounded color="gray-line" />
                  <StarRateRounded color="gray-line" />
                  <StarRateRounded color="gray-line" />
                </Box>
                <Typography>Minimum fit</Typography>
              </Box>
            )
        }
      }

      const message = getJobFit(job_fit)

      return (
        <Box display="flex" alignItems="center" justifyContent="center" columnGap={1}>
          {value ? (
            <Box display="flex" alignItems="center" columnGap={1}>
              {message}
            </Box>
          ) : (
            <Box display="flex" flexDirection="column">
              <Box display="flex" flexDirection="row" marginBottom={0.5}>
                <StarRateRounded color="yellow-01" />
                <StarRateRounded color="gray-line" />
                <StarRateRounded color="gray-line" />
                <StarRateRounded color="gray-line" />
                <StarRateRounded color="gray-line" />
              </Box>
              <Typography>Minimum fit</Typography>
            </Box>
          )}
        </Box>
      )
    },
  },

  {
    Header: 'Attachment',
    accessor: 'relations.candidateable.has_video_interview',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      return (
        <Box display="flex" justifyContent="start" columnGap={2}>
          {props?.row?.original?.relations?.candidateable?.cv_url ? (
            <Tags typo="body1" icon="article" word="Resume" />
          ) : (
            'Not available'
          )}

          {value ? <Tags typo="body1" icon="video_file" word="Video" /> : null}
        </Box>
      )
    },
  },
]
// the same for rejected column
export const ShortlistedColumn = [
  {
    Header: 'Name',
    accessor: 'relations.candidateable.name',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      const date = new Date(props?.row?.original?.created_at)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      const profile_type = props?.row?.original?.relations?.candidateable?.profile_type
      const application_type = props?.row?.original?.relations?.application_type

      const getProfileMessage = (profileType, date) => {
        if (
          application_type === 'self apply' ||
          application_type === 'self apply through job recommender' ||
          application_type === 'self apply & matched' ||
          application_type === 'self apply through job recommender & matched'
        ) {
          switch (profileType) {
            case 'jobseeker':
              return `Applied via adnexio on ${date}`
            case 'job_board':
              return `Applied via Job board on ${date}`
            default:
              return `Applied via External on ${date}`
          }
        } else {
          switch (profileType) {
            case 'jobseeker':
              return `Matched via adnexio`
            case 'job_board':
              return `Matched via Job board`
            default:
              return `Matched via External`
          }
        }
      }
      const message = getProfileMessage(profile_type, formattedDate)
      return (
        <Box display="flex" alignItems="center">
          {props?.row?.original?.relations?.candidateable?.pricing?.is_unlocked ? (
            <Box>
              {props?.row?.original?.relations?.candidateable?.profile_image_url !== null ? (
                <CardMedia
                  component="img"
                  sx={{
                    marginRight: 2,
                    height: 45,
                    width: 45,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                  src={props?.row?.original?.relations?.candidateable?.profile_image_url}
                />
              ) : props?.row?.original?.relations?.application_type ===
                'matched by candidate recommender' ? (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="gray-background.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon
                    sx={{
                      color: 'light-gray-text.main',
                    }}
                  >
                    person_outline_outlined
                  </Icon>
                </Box>
              ) : (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="alternate.main"
                  color="white.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    textTransform: 'capitalize',
                  }}
                >
                  {value?.charAt(0) || '?'}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="gray-background.main"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'light-gray-text.main',
                }}
              >
                locked
              </Icon>
            </Box>
          )}

          <Box display="flex" flexDirection="column" columnGap={2}>
            <Typography sx={{ textTransform: 'capitalize', wordWrap: 'break-word', maxWidth: 500 }}>
              {value || props?.row?.original?.id}
            </Typography>
            <Box display="flex" alignItems="center" columnGap={1}>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor:
                    profile_type === 'jobseeker'
                      ? 'alternate.main'
                      : profile_type === 'job_board'
                      ? 'information.main'
                      : 'yellow-01.main',
                }}
              ></Box>
              <Typography variant="body2" color="light-gray-text.main">
                {message}
              </Typography>
            </Box>
          </Box>
        </Box>
      )
    },
  },

  // {
  //   Header: 'Profile score',
  //   accessor: 'relations.candidateable.profile_scores.total_score',
  //   Cell: (props) => {
  //     const { value } = props
  //     return (
  //       <Box display="flex" alignItems="center" justifyContent="start" columnGap={1}>
  //         {value ? (
  //           <>
  //             <StarsIcon color="yellow-01" />
  //             <Typography>{value ? value : '9.9'}</Typography>
  //           </>
  //         ) : (
  //           <Typography>Not available</Typography>
  //         )}
  //       </Box>
  //     )
  //   },
  // },
  {
    Header: 'Attachment',
    accessor: 'relations.candidateable.has_video_interview',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      return (
        <Box display="flex" justifyContent="start" columnGap={2}>
          {props?.row?.original?.relations?.candidateable?.cv_url ? (
            <Tags typo="body1" icon="article" word="Resume" />
          ) : (
            'Not available'
          )}

          {value ? <Tags typo="body1" icon="video_file" word="Video" /> : null}
        </Box>
      )
    },
  },
]
export const InterviewColumn = [
  {
    Header: 'Name',
    accessor: 'relations.candidateable.name',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      const date = new Date(props?.row?.original?.created_at)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      const profile_type = props?.row?.original?.relations?.candidateable?.profile_type
      const application_type = props?.row?.original?.relations?.application_type

      const getProfileMessage = (profileType, date) => {
        if (
          application_type === 'self apply' ||
          application_type === 'self apply through job recommender' ||
          application_type === 'self apply & matched' ||
          application_type === 'self apply through job recommender & matched'
        ) {
          switch (profileType) {
            case 'jobseeker':
              return `Applied via adnexio on ${date}`
            case 'job_board':
              return `Applied via Job board on ${date}`
            default:
              return `Applied via External on ${date}`
          }
        } else {
          switch (profileType) {
            case 'jobseeker':
              return `Matched via adnexio`
            case 'job_board':
              return `Matched via Job board`
            default:
              return `Matched via External`
          }
        }
      }
      const message = getProfileMessage(profile_type, formattedDate)
      return (
        <Box display="flex" alignItems="center">
          {props?.row?.original?.relations?.candidateable?.pricing?.is_unlocked ? (
            <Box>
              {props?.row?.original?.relations?.candidateable?.profile_image_url !== null ? (
                <CardMedia
                  component="img"
                  sx={{
                    marginRight: 2,
                    height: 45,
                    width: 45,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                  src={props?.row?.original?.relations?.candidateable?.profile_image_url}
                />
              ) : props?.row?.original?.relations?.application_type ===
                'matched by candidate recommender' ? (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="gray-background.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon
                    sx={{
                      color: 'light-gray-text.main',
                    }}
                  >
                    person_outline_outlined
                  </Icon>
                </Box>
              ) : (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="alternate.main"
                  color="white.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    textTransform: 'capitalize',
                  }}
                >
                  {value?.charAt(0) || '?'}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="gray-background.main"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'light-gray-text.main',
                }}
              >
                locked
              </Icon>
            </Box>
          )}

          <Box display="flex" flexDirection="column" columnGap={2}>
            <Typography sx={{ textTransform: 'capitalize', wordWrap: 'break-word', maxWidth: 500 }}>
              {value || props?.row?.original?.id}
            </Typography>
            <Box display="flex" alignItems="center" columnGap={1}>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor:
                    profile_type === 'jobseeker'
                      ? 'alternate.main'
                      : profile_type === 'job_board'
                      ? 'information.main'
                      : 'yellow-01.main',
                }}
              ></Box>
              <Typography variant="body2" color="light-gray-text.main">
                {message}
              </Typography>
            </Box>
          </Box>
        </Box>
      )
    },
  },

  {
    Header: 'Interview detail',
    accessor: 'relations.interviews',
    Cell: (props) => {
      const { value } = props

      const timestamp = new Date(value?.updated_at)
      const updatedTimeStamp = timestamp?.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      const amPmIndex = updatedTimeStamp?.lastIndexOf(' ') + 1
      const capitalizedAmPm = updatedTimeStamp?.slice(amPmIndex, amPmIndex + 2).toUpperCase()
      const formattedTimeStamp = updatedTimeStamp?.slice(0, amPmIndex) + capitalizedAmPm

      const currentTime = new Date()
      const dateTimeObject = new Date(`${value?.end_date}T${value?.end_time}`)

      const checkIsPast = (date) => {
        return currentTime > date
      }
      const pendingStatus = checkIsPast(dateTimeObject)

      const convertDate = (date) => {
        const parts = date?.split('-')
        const interviewStartDate = `${parts[2]}/${parts[1]}/${parts[0]}`
        return interviewStartDate
      }
      const convertTimeTo12HourFormat = (time24) => {
        const [hours, minutes, seconds] = time24?.split(':')
        let period = 'AM'
        let hours12 = parseInt(hours, 10)

        if (hours12 >= 12) {
          period = 'PM'
          if (hours12 > 12) {
            hours12 -= 12
          }
        } else if (hours12 === 0) {
          hours12 = 12 // Midnight (12:00 AM)
        }

        const time12 = `${hours12}:${minutes} ${period}`
        return time12
      }
      return (
        <>
          <Box display="flex" justifyContent="start" columnGap={2}>
            {value?.relations?.interview_status?.interview_status === 'scheduled' &&
              !pendingStatus && (
                <Box sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                  <Tags
                    typo="body1"
                    icon="calendar_month"
                    word={`Scheduled on ${convertDate(
                      value?.start_date
                    )}, ${convertTimeTo12HourFormat(value?.start_time)}`}
                    sxIcon={{
                      color: 'light-gray-text.main',
                      fontSize: '18px',
                    }}
                    sx={{ borderRadius: '4.5px', padding: '8px' }}
                  />
                </Box>
              )}
            {value?.relations?.interview_status?.interview_status === 'scheduled' &&
              pendingStatus && (
                <Box>
                  <Tags
                    typo="body1"
                    icon="error"
                    word="Pending update"
                    color="warning.main"
                    textColor="warning.main"
                    sxIcon={{
                      color: 'warning.main',
                      fontSize: '18px',
                    }}
                    sx={{
                      backgroundColor: 'light-error.main',
                      borderRadius: '4.5px',
                      padding: '8px',
                    }}
                  />
                </Box>
              )}
            {value?.relations?.interview_status?.interview_status === 'cancelled' && (
              <Box>
                <Tags
                  typo="body1"
                  icon="cancel"
                  word={`Cancelled on ${formattedTimeStamp}`}
                  sxIcon={{
                    color: 'error.main',
                    fontSize: '18px',
                  }}
                  sx={{ borderRadius: '4.5px', padding: '8px' }}
                />
              </Box>
            )}
            {value?.relations?.interview_status?.interview_status === 'completed' && (
              <Box>
                <Tags
                  typo="body1"
                  icon="check_circle"
                  word="Completed"
                  sxIcon={{
                    color: 'positive.main',
                    fontSize: '18px',
                  }}
                  sx={{ borderRadius: '4.5px', padding: '8px' }}
                />
              </Box>
            )}
            {value?.relations?.interview_status?.interview_status === 'candidate-no-show' && (
              <Box>
                <Tags
                  typo="body1"
                  icon="help"
                  word="Candidate no-show"
                  sxIcon={{
                    color: 'warning.main',
                    fontSize: '18px',
                  }}
                  sx={{ borderRadius: '4.5px', padding: '8px' }}
                />
              </Box>
            )}
          </Box>
        </>
      )
    },
  },
]

export const OfferColumn = [
  {
    Header: 'Name',
    accessor: 'relations.candidateable.name',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      const date = new Date(props?.row?.original?.created_at)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      const profile_type = props?.row?.original?.relations?.candidateable?.profile_type
      const application_type = props?.row?.original?.relations?.application_type

      const getProfileMessage = (profileType, date) => {
        if (
          application_type === 'self apply' ||
          application_type === 'self apply through job recommender' ||
          application_type === 'self apply & matched' ||
          application_type === 'self apply through job recommender & matched'
        ) {
          switch (profileType) {
            case 'jobseeker':
              return `Applied via adnexio on ${date}`
            case 'job_board':
              return `Applied via Job board on ${date}`
            default:
              return `Applied via External on ${date}`
          }
        } else {
          switch (profileType) {
            case 'jobseeker':
              return `Matched via adnexio`
            case 'job_board':
              return `Matched via Job board`
            default:
              return `Matched via External`
          }
        }
      }
      const message = getProfileMessage(profile_type, formattedDate)
      return (
        <Box display="flex" alignItems="center">
          {props?.row?.original?.relations?.candidateable?.pricing?.is_unlocked ? (
            <Box>
              {props?.row?.original?.relations?.candidateable?.profile_image_url !== null ? (
                <CardMedia
                  component="img"
                  sx={{
                    marginRight: 2,
                    height: 45,
                    width: 45,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                  src={props?.row?.original?.relations?.candidateable?.profile_image_url}
                />
              ) : props?.row?.original?.relations?.application_type ===
                'matched by candidate recommender' ? (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="gray-background.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon
                    sx={{
                      color: 'light-gray-text.main',
                    }}
                  >
                    person_outline_outlined
                  </Icon>
                </Box>
              ) : (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="alternate.main"
                  color="white.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    textTransform: 'capitalize',
                  }}
                >
                  {value?.charAt(0) || '?'}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="gray-background.main"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'light-gray-text.main',
                }}
              >
                locked
              </Icon>
            </Box>
          )}

          <Box display="flex" flexDirection="column" columnGap={2}>
            <Typography sx={{ textTransform: 'capitalize', wordWrap: 'break-word', maxWidth: 500 }}>
              {value || props?.row?.original?.id}
            </Typography>
            <Box display="flex" alignItems="center" columnGap={1}>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor:
                    profile_type === 'jobseeker'
                      ? 'alternate.main'
                      : profile_type === 'job_board'
                      ? 'information.main'
                      : 'yellow-01.main',
                }}
              ></Box>
              <Typography variant="body2" color="light-gray-text.main">
                {message}
              </Typography>
            </Box>
          </Box>
        </Box>
      )
    },
  },

  {
    Header: 'Offered on',
    accessor: 'updated_at',
    Cell: (props) => {
      const { value } = props
      const date = new Date(value)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      return (
        <Box display="flex" alignItems="center" justifyContent="start" columnGap={1}>
          <Typography>{formattedDate}</Typography>
        </Box>
      )
    },
  },
]
export const HiredColumn = [
  {
    Header: 'Name',
    accessor: 'relations.candidateable.name',
    disableSortBy: true,
    Cell: (props) => {
      const { value } = props
      const date = new Date(props?.row?.original?.created_at)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      const profile_type = props?.row?.original?.relations?.candidateable?.profile_type
      const application_type = props?.row?.original?.relations?.application_type

      const getProfileMessage = (profileType, date) => {
        if (
          application_type === 'self apply' ||
          application_type === 'self apply through job recommender' ||
          application_type === 'self apply & matched' ||
          application_type === 'self apply through job recommender & matched'
        ) {
          switch (profileType) {
            case 'jobseeker':
              return `Applied via adnexio on ${date}`
            case 'job_board':
              return `Applied via Job board on ${date}`
            default:
              return `Applied via External on ${date}`
          }
        } else {
          switch (profileType) {
            case 'jobseeker':
              return `Matched via adnexio`
            case 'job_board':
              return `Matched via Job board`
            default:
              return `Matched via External`
          }
        }
      }
      const message = getProfileMessage(profile_type, formattedDate)
      return (
        <Box display="flex" alignItems="center">
          {props?.row?.original?.relations?.candidateable?.pricing?.is_unlocked ? (
            <Box>
              {props?.row?.original?.relations?.candidateable?.profile_image_url !== null ? (
                <CardMedia
                  component="img"
                  sx={{
                    marginRight: 2,
                    height: 45,
                    width: 45,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                  src={props?.row?.original?.relations?.candidateable?.profile_image_url}
                />
              ) : props?.row?.original?.relations?.application_type ===
                'matched by candidate recommender' ? (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="gray-background.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon
                    sx={{
                      color: 'light-gray-text.main',
                    }}
                  >
                    person_outline_outlined
                  </Icon>
                </Box>
              ) : (
                <Box
                  width={45}
                  height={45}
                  borderRadius="50%"
                  bgcolor="alternate.main"
                  color="white.main"
                  marginRight={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    textTransform: 'capitalize',
                  }}
                >
                  {value?.charAt(0) || '?'}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="gray-background.main"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'light-gray-text.main',
                }}
              >
                locked
              </Icon>
            </Box>
          )}

          <Box display="flex" flexDirection="column" columnGap={2}>
            <Typography sx={{ textTransform: 'capitalize', wordWrap: 'break-word', maxWidth: 500 }}>
              {value}
            </Typography>
            <Box display="flex" alignItems="center" columnGap={1}>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor:
                    profile_type === 'jobseeker'
                      ? 'alternate.main'
                      : profile_type === 'job_board'
                      ? 'information.main'
                      : 'yellow-01.main',
                }}
              ></Box>
              <Typography variant="body2" color="light-gray-text.main">
                {message}
              </Typography>
            </Box>
          </Box>
        </Box>
      )
    },
  },
  {
    Header: 'Hired on',
    accessor: 'updated_at',
    Cell: (props) => {
      const { value } = props
      const date = new Date(value)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      return (
        <Box display="flex" alignItems="center" justifyContent="start" columnGap={1}>
          <Typography>{formattedDate}</Typography>
        </Box>
      )
    },
  },
]
